import { del, get, post, put } from "@/services/axiosUitils";

class MotishaService {
  // Category CRUD
  getCategories = async (): Promise<any> => {
    return await get("/motisha_bhakti_kendra/category/");
  };

  createCategory = async (payload: {
    name: string;
    is_active: boolean;
  }): Promise<any> => {
    return await post("/motisha_bhakti_kendra/category/", payload);
  };

  updateCategory = async (
    id: string,
    payload: { name: string; is_active: boolean }
  ): Promise<any> => {
    return await put(`/motisha_bhakti_kendra/category/${id}/`, payload);
  };

  deleteCategory = async (id: string): Promise<any> => {
    return await del(`/motisha_bhakti_kendra/category/${id}/`);
  };

  // Subcategory CRUD
  getSubcategories = async (): Promise<any> => {
    return await get("/motisha_bhakti_kendra/subcategory/");
  };

  createSubcategory = async (payload: {
    name: string;
    category_id: string;
    is_active: boolean;
  }): Promise<any> => {
    return await post("/motisha_bhakti_kendra/subcategory/", payload);
  };

  updateSubcategory = async (
    id: string,
    payload: { name: string; category_id: string; is_active: boolean }
  ): Promise<any> => {
    return await put(`/motisha_bhakti_kendra/subcategory/${id}/`, payload);
  };

  deleteSubcategory = async (id: string): Promise<any> => {
    return await del(`/motisha_bhakti_kendra/subcategory/${id}/`);
  };

  // District CRUD
  getDistricts = async (): Promise<any> => {
    return await get("/motisha_bhakti_kendra/district/");
  };

  createDistrict = async (payload: {
    name: string;
    is_active: boolean;
  }): Promise<any> => {
    return await post("/motisha_bhakti_kendra/district/", payload);
  };

  updateDistrict = async (
    id: string,
    payload: { name: string; is_active: boolean }
  ): Promise<any> => {
    return await put(`/motisha_bhakti_kendra/district/${id}/`, payload);
  };

  deleteDistrict = async (id: string): Promise<any> => {
    return await del(`/motisha_bhakti_kendra/district/${id}/`);
  };

  // City CRUD
  getCities = async (): Promise<any> => {
    return await get("/motisha_bhakti_kendra/city/");
  };

  createCity = async (payload: {
    name: string;
    district_id: string;
    is_active: boolean;
  }): Promise<any> => {
    return await post("/motisha_bhakti_kendra/city/", payload);
  };

  updateCity = async (
    id: string,
    payload: { name: string; district_id: string; is_active: boolean }
  ): Promise<any> => {
    return await put(`/motisha_bhakti_kendra/city/${id}/`, payload);
  };

  deleteCity = async (id: string): Promise<any> => {
    return await del(`/motisha_bhakti_kendra/city/${id}/`);
  };

  // Area CRUD
  getAreas = async (): Promise<any> => {
    return await get("/motisha_bhakti_kendra/area/");
  };

  createArea = async (payload: {
    name: string;
    city_id: string;
    is_active: boolean;
  }): Promise<any> => {
    return await post("/motisha_bhakti_kendra/area/", payload);
  };

  updateArea = async (
    id: string,
    payload: { name: string; city_id: string; is_active: boolean }
  ): Promise<any> => {
    return await put(`/motisha_bhakti_kendra/area/${id}/`, payload);
  };

  deleteArea = async (id: string): Promise<any> => {
    return await del(`/motisha_bhakti_kendra/area/${id}/`);
  };

  // Company CRUD
  getCompanies = async (): Promise<any> => {
    return await get("/motisha_bhakti_kendra/company/");
  };

  createCompany = async (payload: {
    name: string;
    district_id: string;
    city_id: string;
    area_id: string;
    contact: string;
    email: string;
    visiting: string;
    is_active: boolean;
  }): Promise<any> => {
    return await post("/motisha_bhakti_kendra/company/", payload);
  };

  updateCompany = async (
    id: string,
    payload: {
      name: string;
      district_id: string;
      city_id: string;
      area_id: string;
      contact: string;
      email: string;
      visiting: string;
      is_active: boolean;
    }
  ): Promise<any> => {
    return await put(`/motisha_bhakti_kendra/company/${id}/`, payload);
  };

  deleteCompany = async (id: string): Promise<any> => {
    return await del(`/motisha_bhakti_kendra/company/${id}/`);
  };
  // Bank Master CRUD
  getBanks = async (): Promise<any> => {
    return await get("/motisha_bhakti_kendra/bankmaster/");
  };

  createBank = async (payload: {
    bank_name: string;
    branch: string;
    ifsc: string;
    district_id: string;
    city_id: string;
    is_active: boolean;
  }): Promise<any> => {
    return await post("/motisha_bhakti_kendra/bankmaster/", payload);
  };

  updateBank = async (
    id: string,
    payload: {
      bank_name: string;
      branch: string;
      ifsc: string;
      district_id: string;
      city_id: string;
      is_active: boolean;
    }
  ): Promise<any> => {
    return await put(`/motisha_bhakti_kendra/bankmaster/${id}/`, payload);
  };

  deleteBank = async (id: string): Promise<any> => {
    return await del(`/motisha_bhakti_kendra/bankmaster/${id}/`);
  };
}

const instance = new MotishaService();
export default instance;
